import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';

import ElementSortButtons from '../../../components/CampaignEdit/ElementSortButtons';
import PromptLabelContainer from '../../../components/CampaignEdit/PromptLabelContainer';

import { StyledStack } from './styles';

export const CampaignElementWrapper = ({ idx, element, children }) => {
  return (
    <StyledStack>
      <ElementSortButtons idx={idx} />
      <Stack flexGrow={1}>
        {children}
        <PromptLabelContainer
          crakId={element?.crakId}
          campaignElementId={element?.elementTypeId}
          showRequiredSwitch
          idx={idx}
        />
      </Stack>
    </StyledStack>
  );
};

CampaignElementWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, null]),
  element: PropTypes.object,
  idx: PropTypes.number
};

export default CampaignElementWrapper;



// WEBPACK FOOTER //
// ./src/vp-ui/components/CampaignElementWrapper/CampaignElementWrapper.jsx